import { useEffect, useMemo, useRef, useState } from 'react'
import InlineSVG from 'react-inlinesvg'

import sendIcon from '../assets/svg/send.svg';
import saveIcon from '../assets/svg/save.svg';
import clockIcon from '../assets/svg/clock-icon.svg';
import { Button, Col, FormGroup, Input, Label, Modal, ModalBody, ModalFooter, ModalHeader, Row } from 'reactstrap';

export const isValidDateObj = (dt) => {
    try {
        if (dt && typeof dt === 'object') {
            if (dt.day && typeof dt.day === 'number' && dt.day >= 1 && dt.day <= 31) {
                if (dt.month && typeof dt.month === 'number' && dt.month >= 1 && dt.month <= 12) {
                    if (dt.year && typeof dt.year === 'number' && dt.year >= new Date().getFullYear()) {
                        if (typeof dt.hour === 'number' && dt.hour >= 0 && dt.hour <= 23) {
                            if (typeof dt.minute === 'number' && [0, 15, 30, 45].includes(dt.minute)) {
                                const date = new Date(`${String(dt.year).padEnd(4, '0')}-${String(dt.month).padStart(2, '0')}-${String(dt.day).padStart(2, '0')}T${String(dt.hour).padStart(2, '0')}:${String(dt.minute).padStart(2, '0')}:00Z`);
                                const ts = date.getTime();
                                if (ts && !isNaN(ts) && ts > new Date().getTime()) {
                                    return true;
                                }
                            }
                        }
                    }
                }
            }
        }
    } catch (err) {
        console.log('isValidDateObj error: ', err);
    }

    return false;
}

const ChatSendAndSendLaterButtons = ({
    lang,
    disabled,

    onSend,
    onSendLater,

    containerClassName = '',
    sendButtonClassName = '',
    sendLaterButtonClassName = '',
    sendLaterPopupClassName = '',
    saveButtonClassName = '',

    showSave = false,
    onSave,
    existingScheduledDateTime,
    onSaveScheduledDateTime,

    conversationId,
}) => {
    const [showSendLaterPopup, setShowSendLaterPopup] = useState(false);
    const [customDate, setCustomDate] = useState(null);

    const ref = useRef(null);

    useEffect(() => {
        setShowSendLaterPopup(false);
        setCustomDate(null);
    }, [conversationId]);

    useEffect(() => {
        const controller = new AbortController();
        document?.addEventListener('mousedown', (e) => {
            if (!ref?.current?.contains?.(e?.target)) {
                setShowSendLaterPopup(false);
            }
        }, { signal: controller.signal });
        return () => { controller.abort(); };
    }, [setShowSendLaterPopup]);

    return (
        <>
            <div style={{ zIndex: 1 }} className={`send-and-sendlater-container ${containerClassName} ${disabled ? 'isdisabled' : ''}`} >
                {showSave ? <button key='save-btn' type='button' disabled={disabled} onClick={() => {
                    if (showSendLaterPopup) return;
                    onSave?.();
                }} className={`save-button ${saveButtonClassName}`} >
                    <InlineSVG src={saveIcon} />
                    <div className='send-and-sendlater-button-tooltip' hidden={disabled || showSendLaterPopup}>
                        {'Save changes'.translate(lang)}
                    </div>
                </button> : <button key='send-btn' type='button' disabled={disabled} onClick={() => {
                    if (showSendLaterPopup) return;
                    onSend?.();
                }} className={`send-button ${sendButtonClassName}`} >
                    <InlineSVG src={sendIcon} />
                    <div className='send-and-sendlater-button-tooltip' hidden={disabled || showSendLaterPopup}>
                        {'Send now'.translate(lang)}
                    </div>
                </button>}

                <div className='divider' aria-hidden />
                <div className='send-later-container' ref={ref}>
                    {showSendLaterPopup ? (
                        <div className={`send-later-popup ${sendLaterPopupClassName}`} >
                            <div>{'Schedule message'.translate(lang)}</div>
                            <div className='horizontal-divider' />
                            <button key='tm' type='button' onClick={() => {
                                const now = new Date();
                                const tomorrow = new Date(now.getTime() + 24 * 60 * 60 * 1000);
                                const dt = {
                                    day: tomorrow.getDate(),
                                    month: tomorrow.getMonth() + 1,
                                    year: tomorrow.getFullYear(),
                                    hour: 12,
                                    minute: 0,
                                }
                                onSendLater?.(dt);
                                setShowSendLaterPopup(false);
                            }}>
                                {'Tomorrow at 12:00'.translate(lang)}
                            </button>
                            <button key='nw' type='button' onClick={() => {
                                const now = new Date();
                                const nextMonday = new Date(now.getTime() + (7 - now.getDay() + 1) * 24 * 60 * 60 * 1000);
                                const dt = {
                                    day: nextMonday.getDate(),
                                    month: nextMonday.getMonth() + 1,
                                    year: nextMonday.getFullYear(),
                                    hour: 12,
                                    minute: 0,
                                }
                                onSendLater?.(dt);
                                setShowSendLaterPopup(false);
                            }}>
                                {'Next week at 12:00'.translate(lang)}
                            </button>
                            <div className='horizontal-divider' />
                            <button key='custom' type='button' onClick={() => {
                                const now = new Date();
                                setCustomDate({
                                    day: now.getDate(),
                                    month: now.getMonth() + 1,
                                    year: now.getFullYear(),
                                    hour: now.getHours() + 1 >= 24 ? 0 : now.getHours() + 1,
                                    minute: 0,
                                });
                                setShowSendLaterPopup(false);
                            }}>
                                {'Custom time'.translate(lang)}
                            </button>
                        </div>
                    ) : null}
                    <button type='button' disabled={disabled || (showSave && !existingScheduledDateTime)} onClick={() => {
                        if (showSave && existingScheduledDateTime) {
                            setCustomDate(existingScheduledDateTime);
                            return;
                        }
                        if (showSave && !existingScheduledDateTime) return;
                        const now = new Date();
                        setCustomDate({
                            day: now.getDate(),
                            month: now.getMonth() + 1,
                            year: now.getFullYear(),
                            hour: now.getHours() + 1 >= 24 ? 0 : now.getHours() + 1,
                            minute: 0,
                        });
                        setShowSendLaterPopup(false);
                        return;
                        setShowSendLaterPopup(prev => !prev);
                    }} className={`send-later-button ${sendLaterButtonClassName}`} >
                        <InlineSVG src={clockIcon} />
                        <div className='send-and-sendlater-button-tooltip' hidden={disabled || showSendLaterPopup}>
                            {showSave && existingScheduledDateTime ? 'Change time'.translate(lang) : 'Schedule for later'.translate(lang)}
                        </div>
                    </button>
                </div>
            </div>

            {customDate ? (
                <CustomDateModal
                    lang={lang}
                    date={customDate}
                    setDate={(dt) => {
                        setCustomDate(prev => ({
                            ...prev,
                            ...dt,
                        }))
                    }}
                    onConfirm={() => {
                        if (!isValidDateObj(customDate)) return;
                        if (showSave && existingScheduledDateTime) {
                            onSaveScheduledDateTime?.(customDate);
                            setCustomDate(null);
                            return;
                        }
                        onSendLater?.(customDate);
                        setCustomDate(null);
                    }}
                    onCancel={() => setCustomDate(null)}
                />
            ) : null}
        </>
    )
}

export const CustomDateModal = ({
    lang,
    date: customDate,
    setDate: setCustomDate,
    onConfirm,
    onCancel,
}) => {

    const dateValue = useMemo(() => `${String(customDate.year).padStart(4, '0')}-${String(customDate.month).padStart(2, '0')}-${String(customDate.day).padStart(2, '0')}`, [customDate]);
    const timeValue = useMemo(() => `${String(customDate.hour).padStart(2, '0')}:${String(customDate.minute).padStart(2, '0')}`, [customDate]);

    const minDate = useMemo(() => {
        return new Date().toISOString().split('T')[0];
    }, []);
    const maxDate = useMemo(() => {
        return new Date(new Date().getTime() + 90 * 24 * 60 * 60 * 1000).toISOString().split('T')[0];
    }, []);
    const options = useMemo(() => {
        const options = [];
        const now = new Date();
        const td = now.getDate();
        const tm = now.getMonth() + 1;
        const ty = now.getFullYear();

        if (td === customDate.day && tm === customDate.month && ty === customDate.year) {
            // Today
            const th = now.getHours();
            const tm = now.getMinutes();

            for (let h = th; h < 24; h++) {
                for (let m = 0; m < 60; m += 15) {
                    if (h === th && m <= tm) continue;
                    options.push({
                        hour: h,
                        minute: m,
                    });
                }
            }
        } else {
            // In the future;
            for (let h = 0; h < 24; h++) {
                for (let m = 0; m < 60; m += 15) {
                    options.push({
                        hour: h,
                        minute: m,
                    });
                }
            }
        }

        return options;
    }, [customDate]);

    return <>
        <Modal isOpen={true} toggle={onCancel} centered size='md'>
            <ModalHeader>
                {'Schedule message'.translate(lang)}
            </ModalHeader>
            <ModalBody>
                <Row>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>{'Date'.translate(lang)}</Label>
                            <Input
                                type='date'
                                onChange={(e) => {
                                    const value = e.target.value;
                                    const [year, month, day] = value.split('-').map(Number);
                                    setCustomDate({
                                        year, month, day
                                    });
                                }}
                                required
                                value={dateValue}
                                min={minDate}
                                max={maxDate}
                                onKeyDown={(e) => e.preventDefault()}
                            />
                        </FormGroup>
                    </Col>
                    <Col sm='6'>
                        <FormGroup>
                            <Label>{'Time'.translate(lang)}</Label>
                            <div className='custom-select-time'>
                                <Input
                                    type='select'
                                    onChange={(e) => {
                                        const value = e.target.value;
                                        const [hour, minute] = value.split(':').map(Number);
                                        setCustomDate({
                                            hour, minute
                                        });
                                    }}
                                    required
                                    value={timeValue}
                                >
                                    {options.map(opt => {
                                        const str = `${String(opt.hour).padStart(2, '0')}:${String(opt.minute).padStart(2, '0')}`;

                                        return <option key={str} value={str}>{str}</option>
                                    })}
                                </Input>
                                <InlineSVG src={clockIcon} />
                            </div>
                        </FormGroup>
                    </Col>
                </Row>
            </ModalBody>
            <ModalFooter style={{ display: 'flex', alignItems: 'center', justifyContent: 'flex-end', gap: 5 }}>
                <button style={{ display: 'none', visibility: 'hidden' }} hidden aria-hidden />
                <Button style={{ minWidth: 100 }} type='button' size='lg' color='primary' onClick={onCancel}>
                    {'Cancel'.translate(lang)}
                </Button>
                <Button className='send-later-confirm-button-modal' style={{ minWidth: 100, backgroundColor: '#3ea9a5 !important', borderColor: '#3ea9a5 !important' }} color='info' type='button' size='lg' onClick={onConfirm} disabled={!isValidDateObj(customDate)}>
                    {'Confirm'.translate(lang)}
                </Button>
                <button style={{ display: 'none', visibility: 'hidden' }} hidden aria-hidden />
            </ModalFooter>
        </Modal>
    </>
}

export default ChatSendAndSendLaterButtons